module.exports = __webpack_public_path__ + "static/media/googlescholar.4841811a.svg";